function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}    

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    
    this.sectionId = this.getSectionId();
    this.inventoryData = this.getInventoryData();
    this.currentVariantId = this.getCurrentVariantId();
    this.context = this.getContext();
    
    this.input = this.querySelector('.quantity__input');
    this.changeEvent = new Event('change', { bubbles: true });
    
    this.createStockDisplay();
    this.updateStockDisplay();
    
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
    
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.input.addEventListener('blur', this.onInputBlur.bind(this));
    
    // Check if this is a cart quantity input and look for product page quantity input
    if (this.context === 'cart') {
      // Look for product page quantity inputs that might not have been processed
      const productPageQuantityInputs = document.querySelectorAll('quantity-input:not([data-cart-item])');
      console.log('Found product page quantity inputs:', productPageQuantityInputs.length);
      productPageQuantityInputs.forEach((input, index) => {
        console.log(`Product page quantity input ${index + 1}:`, input);
        console.log(`- Has data-processed:`, input.hasAttribute('data-processed'));
        console.log(`- Closest product-form:`, !!input.closest('product-form'));
        console.log(`- Closest .product-form:`, !!input.closest('.product-form'));
        
        if (input !== this && !input.hasAttribute('data-processed')) {
          input.setAttribute('data-processed', 'true');
          // Force the product page quantity input to initialize
          if (input.sectionId === undefined) {
            // Safety check: ensure methods exist
            if (typeof input.getSectionId === 'function' && 
                typeof input.getInventoryData === 'function' && 
                typeof input.getCurrentVariantId === 'function' && 
                typeof input.getContext === 'function' &&
                typeof input.createStockDisplay === 'function' &&
                typeof input.updateStockDisplay === 'function') {
              
              input.sectionId = input.getSectionId();
              input.inventoryData = input.getInventoryData();
              input.currentVariantId = input.getCurrentVariantId();
              input.context = input.getContext();
              input.input = input.querySelector('.quantity__input');
              input.createStockDisplay();
              input.updateStockDisplay();
              console.log(`Processed product page quantity input ${index + 1}`);
            } else {
              console.log(`Skipping quantity input ${index + 1} - missing required methods`);
            }
          }
        }
      });
      
      // Also check all quantity inputs to understand the structure
      const allQuantityInputs = document.querySelectorAll('quantity-input');
      console.log('Total quantity inputs on page:', allQuantityInputs.length);
      allQuantityInputs.forEach((input, index) => {
        console.log(`All quantity input ${index + 1}:`, input);
        console.log(`- Has data-cart-item:`, input.hasAttribute('data-cart-item'));
        console.log(`- Has data-processed:`, input.hasAttribute('data-processed'));
        console.log(`- Context:`, input.context || 'not set');
      });
    }
    
    // Also process any unprocessed quantity inputs regardless of context
    setTimeout(() => {
      const unprocessedInputs = document.querySelectorAll('quantity-input:not([data-processed])');
      console.log('Unprocessed quantity inputs found:', unprocessedInputs.length);
      unprocessedInputs.forEach((input, index) => {
        if (input !== this) {
          console.log(`Processing unprocessed quantity input ${index + 1}:`, input);
          input.setAttribute('data-processed', 'true');
          
          // Safety check: ensure methods exist
          if (typeof input.getSectionId === 'function' && 
              typeof input.getInventoryData === 'function' && 
              typeof input.getCurrentVariantId === 'function' && 
              typeof input.getContext === 'function' &&
              typeof input.createStockDisplay === 'function' &&
              typeof input.updateStockDisplay === 'function') {
            
            input.sectionId = input.getSectionId();
            input.inventoryData = input.getInventoryData();
            input.currentVariantId = input.getCurrentVariantId();
            input.context = input.getContext();
            input.input = input.querySelector('.quantity__input');
            input.createStockDisplay();
            input.updateStockDisplay();
            console.log(`Processed unprocessed quantity input ${index + 1} with context:`, input.context);
          } else {
            console.log(`Skipping unprocessed quantity input ${index + 1} - missing required methods`);
          }
        }
      });
    }, 100);
  }

  getContext() {
    // Determine the context of this quantity input
    
    // Check for cart context - must have data-cart-item attribute AND be in cart context
    if (this.hasAttribute('data-cart-item')) {
      // Additional check: make sure we're actually in a cart context
      const cartContext = this.closest('.cart-notification-product__footer, .cart__item--footer, .cart-item');
      if (cartContext) {
        
        // Check if this is actually a cart drawer or mini-cart
        const cartDrawer = this.closest('.cart-notification, .cart-drawer, .mini-cart, [data-cart-drawer]');
        const isInCartDrawer = !!cartDrawer;
        
        if (isInCartDrawer) {
          return 'cart';
        } else {
          return 'product-page';
        }
      } else {
        return 'product-page';
      }
    }
    
    // Check for product card context
    if (this.closest('.product-card') || this.closest('[data-product-card]')) {
      return 'product-card';
    }
    
    // Check for vehicle search context
    if (this.closest('.vehicle-search') || this.closest('[data-vehicle-search]')) {
      return 'vehicle-search';
    }
    
    // Check for product page context - must be inside product-form element
    const productFormElement = this.closest('product-form');
    if (productFormElement) {
      return 'product-page';
    }
    
    // Check for product form class
    const productFormClass = this.closest('.product-form');
    if (productFormClass) {
      return 'product-page';
    }
    
    // Check for quick view context
    if (this.closest('.quick-view')) {
      return 'quick-view';
    }
    
    // If we're on a product page but none of the above matched, still treat as product-page
    if (window.location.pathname.includes('/products/')) {
      return 'product-page';
    }
    
    return 'default';
  }

  getSectionId() {
    // Try to get section ID from various sources
    const productForm = this.closest('product-form');
    if (productForm) {
      const form = productForm.querySelector('form');
      if (form) {
        const quantityInput = form.querySelector('input[name="quantity"]');
        if (quantityInput && quantityInput.id) {
          return quantityInput.id.replace('Quantity-', '');
        }
      }
    }
    
    // Fallback: look for any section ID in parent elements
    const sectionElement = this.closest('[data-section-id]');
    if (sectionElement) {
      return sectionElement.getAttribute('data-section-id');
    }
    
    return null;
  }

  getInventoryData() {
    // Check if this is a cart item
    if (this.hasAttribute('data-cart-item')) {
      const variantId = this.getAttribute('data-variant-id');
      const inventoryQty = parseInt(this.getAttribute('data-inventory-qty')) || 0;
      const inventoryPolicy = this.getAttribute('data-inventory-policy') || 'deny';
      
      console.log('Cart item inventory data:', {
        variantId: variantId,
        inventoryQty: inventoryQty,
        inventoryPolicy: inventoryPolicy,
        context: this.context
      });
      
      return {
        [variantId]: {
          qty: inventoryQty,
          inventory_policy: inventoryPolicy
        }
      };
    }
    
    // Check if this is a product card
    if (this.context === 'product-card') {
      const productCard = this.closest('.product-card, [data-product-card]');
      if (productCard) {
        const variantId = productCard.getAttribute('data-variant-id');
        const inventoryQty = parseInt(productCard.getAttribute('data-inventory-qty')) || 0;
        const inventoryPolicy = productCard.getAttribute('data-inventory-policy') || 'deny';
        
        return {
          [variantId]: {
            qty: inventoryQty,
            inventory_policy: inventoryPolicy
          }
        };
      }
    }
    
    // Check if this is in vehicle search
    if (this.context === 'vehicle-search') {
      const vehicleSearchItem = this.closest('.vehicle-search-item, [data-vehicle-item]');
      if (vehicleSearchItem) {
        const variantId = vehicleSearchItem.getAttribute('data-variant-id');
        const inventoryQty = parseInt(vehicleSearchItem.getAttribute('data-inventory-qty')) || 0;
        const inventoryPolicy = vehicleSearchItem.getAttribute('data-inventory-policy') || 'deny';
        
        return {
          [variantId]: {
            qty: inventoryQty,
            inventory_policy: inventoryPolicy
          }
        };
      }
    }
    
    // Get inventory data from the preorder script tag for product pages
    const preorderScript = document.querySelector('script[data-preorder]');
    if (preorderScript) {
      try {
        const data = JSON.parse(preorderScript.textContent);
        console.log('Found real inventory data from preorder script:', data);
        return data;
      } catch (e) {
        console.warn('Could not parse inventory data:', e);
        console.log('Raw script content:', preorderScript.textContent);
        return {};
      }
    } else {
      console.log('No preorder script found - searching for alternative sources');
      
      // Look for inventory data in other script tags
      const allScripts = document.querySelectorAll('script');
      let inventoryData = {};
      
      // Search for any script containing inventory data
      allScripts.forEach((script, index) => {
        const content = script.textContent;
        if (content.includes('inventory_quantity') || content.includes('inventory_policy')) {
          console.log(`Found potential inventory data in script ${index + 1}:`, script);
          console.log('Script content preview:', content.substring(0, 200));
          
          // Try to extract JSON data from the script
          try {
            // Look for JSON patterns in the script
            const jsonMatches = content.match(/\{[^{}]*"[^"]*"[^{}]*\}/g);
            if (jsonMatches) {
              jsonMatches.forEach(match => {
                try {
                  const parsed = JSON.parse(match);
                  if (parsed && typeof parsed === 'object') {
                    console.log('Parsed potential inventory data:', parsed);
                    // Check if this looks like inventory data
                    const keys = Object.keys(parsed);
                    if (keys.length > 0 && keys.every(key => 
                      parsed[key] && typeof parsed[key] === 'object' && 
                      (parsed[key].qty !== undefined || parsed[key].inventory_quantity !== undefined)
                    )) {
                      console.log('Found valid inventory data structure:', parsed);
                      inventoryData = { ...inventoryData, ...parsed };
                    }
                  }
                } catch (e) {
                  // Not valid JSON, continue
                }
              });
            }
          } catch (e) {
            // Script doesn't contain valid JSON
          }
        }
      });
      
      if (Object.keys(inventoryData).length > 0) {
        console.log('Using found inventory data:', inventoryData);
        return inventoryData;
      }
      
      // Debug: check for any script tags with data attributes
      const scriptsWithData = Array.from(allScripts).filter(script => {
        const attributes = script.getAttributeNames();
        return attributes.some(attr => attr.startsWith('data-'));
      });
      console.log('Scripts with data attributes found:', scriptsWithData.length);
      scriptsWithData.forEach((script, index) => {
        console.log(`Script ${index + 1}:`, script);
        console.log(`- data attributes:`, script.getAttributeNames().filter(attr => attr.startsWith('data-')));
        console.log(`- content:`, script.textContent.substring(0, 100) + '...');
      });
      
      // Also look for any script tags that might contain variant data
      const variantScripts = Array.from(allScripts).filter(script => {
        return script.textContent.includes('inventory_quantity') || 
               script.textContent.includes('inventory_policy') ||
               script.textContent.includes('variant');
      });
      console.log('Scripts with variant data found:', variantScripts.length);
      variantScripts.forEach((script, index) => {
        console.log(`Variant Script ${index + 1}:`, script);
        console.log(`- content:`, script.textContent.substring(0, 200) + '...');
      });
      
      // Missing inventory is unknown, not a test quantity. Existing unknown-stock
      // UI handles an empty object; Shopify still validates availability at checkout.
      return {};
    }
  }
  
  // Method to fetch real inventory data from Shopify API
  async fetchInventoryFromAPI() {
    try {
      const productId = this.getProductId();
      if (!productId) {
        console.log('No product ID found for API call');
        return {};
      }
      
      console.log('Fetching inventory data from API for product:', productId);
      const response = await fetch(`/products/${productId}.js`);
      const productData = await response.json();
      
      const inventoryData = {};
      productData.variants.forEach(variant => {
        inventoryData[variant.id] = {
          qty: variant.inventory_quantity,
          inventory_policy: variant.inventory_policy
        };
      });
      
      console.log('Fetched real inventory data from API:', inventoryData);
      return inventoryData;
    } catch (error) {
      console.error('Error fetching inventory from API:', error);
      return {};
    }
  }
  
  // Helper method to get product ID from URL
  getProductId() {
    const path = window.location.pathname;
    const match = path.match(/\/products\/([^\/]+)/);
    return match ? match[1] : null;
  }

  getCurrentVariantId() {
    // For cart items, get variant ID from data attribute
    if (this.hasAttribute('data-cart-item')) {
      const variantId = this.getAttribute('data-variant-id');
      return variantId;
    }
    
    // For product cards
    if (this.context === 'product-card') {
      const productCard = this.closest('.product-card, [data-product-card]');
      const variantId = productCard ? productCard.getAttribute('data-variant-id') : null;
      return variantId;
    }
    
    // For vehicle search items
    if (this.context === 'vehicle-search') {
      const vehicleSearchItem = this.closest('.vehicle-search-item, [data-vehicle-item]');
      const variantId = vehicleSearchItem ? vehicleSearchItem.getAttribute('data-variant-id') : null;
      return variantId;
    }
    
    // Get current variant ID from hidden input for product pages
    const form = this.closest('form');
    if (form) {
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput && variantInput.value) {
        console.log('Found variant ID from form input:', variantInput.value);
        return variantInput.value;
      }
    }
    
    // Fallback: try to get from product form
    const productForm = this.closest('product-form');
    if (productForm) {
      const form = productForm.querySelector('form');
      if (form) {
        const variantInput = form.querySelector('input[name="id"]');
        if (variantInput && variantInput.value) {
          console.log('Found variant ID from product form:', variantInput.value);
          return variantInput.value;
        }
      }
    }
    
    // Additional fallback: look for variant selects
    const variantSelects = this.closest('variant-selects');
    if (variantSelects && variantSelects.currentVariant) {
      console.log('Found variant ID from variant-selects:', variantSelects.currentVariant.id);
      return variantSelects.currentVariant.id.toString();
    }
    
    console.log('No variant ID found - checking all possible sources');
    console.log('- Has data-cart-item:', this.hasAttribute('data-cart-item'));
    console.log('- Context:', this.context);
    console.log('- Closest form:', !!this.closest('form'));
    console.log('- Closest product-form:', !!this.closest('product-form'));
    console.log('- Closest variant-selects:', !!this.closest('variant-selects'));
    
    // Final fallback: return first variant ID from inventory data
    const inventoryKeys = Object.keys(this.inventoryData);
    if (inventoryKeys.length > 0) {
      console.log('Using first inventory key as fallback variant ID:', inventoryKeys[0]);
      return inventoryKeys[0];
    }
    
    console.log('No variant ID found');
    return null;
  }

  createStockDisplay() {
    
    // Check if stock display already exists in the footer
    const footer = this.closest('.cart-notification-product__footer, .cart__item--footer');
    if (footer && footer.querySelector('.quantity-stock-display')) {
      return;
    }
    
    // Check if stock display already exists in this element
    if (this.querySelector('.quantity-stock-display')) {
      return;
    }
    
    const stockDisplay = document.createElement('div');
    stockDisplay.className = 'quantity-stock-display';
    
    // Ensure variantStrings is available
    if (!window.variantStrings) {
      window.variantStrings = {
        stock: 'Stock',
        outOfStock: 'Out of stock',
        preorder: 'Pre-order'
      };
    }
    
    // Different display based on context
    if (this.context === 'cart') {
      stockDisplay.innerHTML = `
        <span class="stock-label">${window.variantStrings.stock}:</span>
        <span class="stock-amount"></span>
        <span class="stock-warning" style="display: none;"></span>
        <span class="stock-error" style="display: none;"></span>
      `;
    } else if (this.context === 'product-card' || this.context === 'vehicle-search') {
      stockDisplay.innerHTML = `
        <span class="stock-label">${window.variantStrings.stock}:</span>
        <span class="stock-amount"></span>
        <span class="stock-error" style="display: none;"></span>
      `;
    } else {
      stockDisplay.innerHTML = `
        <span class="stock-label">${window.variantStrings.stock}:</span>
        <span class="stock-amount"></span>
        <span class="stock-error" style="display: none;"></span>
      `;
    }
    
    // For cart context, insert into the footer instead of directly after quantity input
    if (this.context === 'cart') {
      if (footer) {
        // Insert after the quantity input but before the remove button
        const removeButton = footer.querySelector('cart-remove-button-2, .remove-link');
        if (removeButton) {
          footer.insertBefore(stockDisplay, removeButton);
        } else {
          footer.appendChild(stockDisplay);
        }
      } else {
        // Fallback: insert after the quantity input
        this.appendChild(stockDisplay);
      }
    } else if (this.context === 'product-page') {
      // For product page, insert into the product-form__input.product-form__quantity container
      
      const productFormQuantity = this.closest('.product-form__input.product-form__quantity');
      
      if (productFormQuantity) {
        productFormQuantity.appendChild(stockDisplay);
      } else {
        // Fallback: try just product-form__quantity
        const fallbackContainer = this.closest('.product-form__quantity');
        
        if (fallbackContainer) {
          fallbackContainer.appendChild(stockDisplay);
        } else {
          // Final fallback: insert after the quantity input
          this.appendChild(stockDisplay);
        }
      }
    } else {
      // Insert after the quantity input for other contexts
      this.appendChild(stockDisplay);
    }
  }

  updateStockDisplay() {
    // Find stock display based on context
    let stockDisplay = null;
    
    if (this.context === 'cart') {
      // For cart context, look in footer first
      const footer = this.closest('.cart-notification-product__footer, .cart__item--footer');
      stockDisplay = footer ? footer.querySelector('.quantity-stock-display') : null;
    } else if (this.context === 'product-page') {
      // For product page, look in product-form__input.product-form__quantity container
      const productFormQuantity = this.closest('.product-form__input.product-form__quantity');
      stockDisplay = productFormQuantity ? productFormQuantity.querySelector('.quantity-stock-display') : null;
      
      // Fallback: try just product-form__quantity
      if (!stockDisplay) {
        const fallbackContainer = this.closest('.product-form__quantity');
        stockDisplay = fallbackContainer ? fallbackContainer.querySelector('.quantity-stock-display') : null;
      }
    }
    
    // Fallback: look in this element
    if (!stockDisplay) {
      stockDisplay = this.querySelector('.quantity-stock-display');
    }
    
    if (!stockDisplay) {
      this.createStockDisplay();
      
      // Try to find the stock display again after creation
      if (this.context === 'cart') {
        const footer = this.closest('.cart-notification-product__footer, .cart__item--footer');
        stockDisplay = footer ? footer.querySelector('.quantity-stock-display') : null;
      } else if (this.context === 'product-page') {
        const productFormQuantity = this.closest('.product-form__input.product-form__quantity');
        stockDisplay = productFormQuantity ? productFormQuantity.querySelector('.quantity-stock-display') : null;
        
        // Fallback: try just product-form__quantity
        if (!stockDisplay) {
          const fallbackContainer = this.closest('.product-form__quantity');
          stockDisplay = fallbackContainer ? fallbackContainer.querySelector('.quantity-stock-display') : null;
        }
      }
      
      if (!stockDisplay) {
        stockDisplay = this.querySelector('.quantity-stock-display');
      }
      
      if (!stockDisplay) {
        return;
      }
    }

    const stockAmount = stockDisplay.querySelector('.stock-amount');
    const stockError = stockDisplay.querySelector('.stock-error');
    const stockWarning = stockDisplay.querySelector('.stock-warning');
    
    if (!stockAmount) {
      return;
    }
    
    // Clear any previous messages
    if (stockError) stockError.style.display = 'none';
    if (stockWarning) stockWarning.style.display = 'none';
    
    if (!this.currentVariantId || !this.inventoryData[this.currentVariantId]) {
      // For cart items, show a more helpful message
      if (this.context === 'cart') {
        stockAmount.textContent = 'Check product page for stock';
        stockAmount.className = 'stock-amount cart-info';
      } else {
        stockAmount.textContent = 'N/A';
      }
      console.log('No variant data found - showing N/A');
      console.log('currentVariantId:', this.currentVariantId);
      console.log('inventoryData keys:', Object.keys(this.inventoryData));
      return;
    }

    const variantData = this.inventoryData[this.currentVariantId];
    const availableStock = variantData.qty;
    const inventoryPolicy = variantData.inventory_policy;
    const currentQuantity = parseInt(this.input.value) || 0;
    
    console.log('Updating stock display with:', {
      currentVariantId: this.currentVariantId,
      availableStock: availableStock,
      inventoryPolicy: inventoryPolicy,
      context: this.context,
      allInventoryKeys: Object.keys(this.inventoryData)
    });
    
    if (availableStock <= 0) {
      if (inventoryPolicy === 'continue') {
        stockAmount.textContent = window.variantStrings?.preorder || 'Pre-order';
        stockAmount.className = 'stock-amount preorder';
      } else {
        stockAmount.textContent = window.variantStrings?.outOfStock || 'Out of stock';
        stockAmount.className = 'stock-amount out-of-stock';
        
        // Show warning for cart items with out-of-stock products
        if (this.context === 'cart' && currentQuantity > 0) {
          this.showStockWarning('This item is out of stock. Consider removing it from your cart.');
        }
      }
    } else {
      stockAmount.textContent = availableStock;
      stockAmount.className = 'stock-amount in-stock';
      console.log('Stock amount set to:', availableStock);
      
      // Set max attribute on input
      this.input.setAttribute('max', availableStock);
      
      // Show warning for cart items with low stock
      if (this.context === 'cart' && currentQuantity > availableStock) {
        this.showStockWarning(`Only ${availableStock} items available. Your cart has ${currentQuantity}.`);
      } else if (this.context === 'cart' && availableStock <= 5 && currentQuantity > 0) {
        this.showStockWarning(`Low stock: Only ${availableStock} items remaining.`);
      }
    }
  }

  validateQuantity(quantity) {
    if (!this.currentVariantId || !this.inventoryData[this.currentVariantId]) {
      return { valid: true, message: '' };
    }

    const variantData = this.inventoryData[this.currentVariantId];
    const availableStock = variantData.qty;
    const inventoryPolicy = variantData.inventory_policy;
    
    if (availableStock <= 0) {
      if (inventoryPolicy === 'continue') {
        return { valid: true, message: '' }; // Allow pre-order
      } else {
        return { 
          valid: false, 
          message: window.variantStrings?.outOfStock || 'Out of stock' 
        };
      }
    }
    
    if (quantity > availableStock) {
      return { 
        valid: false, 
        message: `Only ${availableStock} items available` 
      };
    }
    
    return { valid: true, message: '' };
  }

  showError(message) {
    const stockError = this.querySelector('.stock-error');
    if (stockError) {
      stockError.textContent = message;
      stockError.style.display = 'block';
      
      // Hide error after 3 seconds
      setTimeout(() => {
        stockError.style.display = 'none';
      }, 3000);
    }
  }

  showStockWarning(message) {
    // Find stock display in the footer first, then in this element
    const footer = this.closest('.cart-notification-product__footer, .cart__item--footer');
    let stockDisplay = footer ? footer.querySelector('.quantity-stock-display') : null;
    
    if (!stockDisplay) {
      stockDisplay = this.querySelector('.quantity-stock-display');
    }
    
    if (stockDisplay) {
      const stockWarning = stockDisplay.querySelector('.stock-warning');
      if (stockWarning) {
        stockWarning.textContent = message;
        stockWarning.style.display = 'block';
      }
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = parseInt(this.input.value) || 1;
    const newValue = event.target.name === "plus" 
      ? previousValue + 1 
      : Math.max(1, previousValue - 1);

    // Validate the new quantity
    const validation = this.validateQuantity(newValue);
    if (!validation.valid) {
      this.showError(validation.message);
      return;
    }

    // Update input value
    this.input.value = newValue;
    
    if (previousValue !== newValue) {
      this.input.dispatchEvent(this.changeEvent);
    }
    
    // Update stock display for cart items
    if (this.context === 'cart') {
      this.updateStockDisplay();
    }
  }

  onInputChange(event) {
    const value = parseInt(event.target.value) || 0;
    const validation = this.validateQuantity(value);
    
    if (!validation.valid) {
      this.showError(validation.message);
    } else {
      // Clear error if quantity is valid
      const stockError = this.querySelector('.stock-error');
      if (stockError) {
        stockError.style.display = 'none';
      }
    }
    
    // Update stock display for cart items
    if (this.context === 'cart') {
      this.updateStockDisplay();
    }
  }

  onInputBlur(event) {
    const value = parseInt(event.target.value) || 0;
    
    // Ensure minimum value of 1
    if (value < 1) {
      this.input.value = 1;
      this.input.dispatchEvent(this.changeEvent);
    }
    
    // Check if value exceeds available stock
    if (this.currentVariantId && this.inventoryData[this.currentVariantId]) {
      const availableStock = this.inventoryData[this.currentVariantId].qty;
      if (availableStock > 0 && value > availableStock) {
        this.input.value = availableStock;
        this.showError(`Quantity adjusted to maximum available: ${availableStock}`);
        this.input.dispatchEvent(this.changeEvent);
      }
    }
  }

  // Method to update variant (called when variant changes)
  updateVariant(variantId) {
    console.log('updateVariant called with variantId:', variantId);
    this.currentVariantId = variantId;
    
    // Refresh inventory data in case it changed
    this.inventoryData = this.getInventoryData();
    
    this.updateStockDisplay();
    
    // Reset input value to 1 when variant changes
    this.input.value = 1;
    this.input.dispatchEvent(this.changeEvent);
  }

  // Method to check cart stock status
  checkCartStockStatus() {
    if (this.context !== 'cart') return;
    
    const currentQuantity = parseInt(this.input.value) || 0;
    const variantData = this.inventoryData[this.currentVariantId];
    
    if (!variantData) return;
    
    const availableStock = variantData.qty;
    const inventoryPolicy = variantData.inventory_policy;
    
    if (availableStock <= 0 && inventoryPolicy !== 'continue') {
      // Item is out of stock
      this.showStockWarning('This item is out of stock. Consider removing it from your cart.');
    } else if (currentQuantity > availableStock && availableStock > 0) {
      // Cart quantity exceeds available stock
      this.showStockWarning(`Only ${availableStock} items available. Your cart has ${currentQuantity}.`);
    } else if (availableStock <= 5 && currentQuantity > 0) {
      // Low stock warning
      this.showStockWarning(`Low stock: Only ${availableStock} items remaining.`);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

// Shopify editor
function editorShopifyEvent(t,e,i){let n=!1;t.type.includes("shopify:section")?e.hasAttribute("data-section-id")&&e.getAttribute("data-section-id")===t.detail.sectionId&&(n=!0):t.type.includes("shopify:block")&&t.target===e&&(n=!0),n&&i(t)}

// Shopify Currency Symbol
const currencySymbol={AED:"د.إ",AFN:"؋",ALL:"L",AMD:"֏",ANG:"ƒ",AOA:"Kz",ARS:"$",AUD:"$",AWG:"ƒ",AZN:"₼",BAM:"KM",BBD:"$",BDT:"Tk",BGN:"лв",BHD:".د.ب",BIF:"FBu",BMD:"$",BND:"$",BOB:"$b",BOV:"BOV",BRL:"R$",BSD:"$",BTC:"₿",BTN:"Nu.",BWP:"P",BYN:"Br",BYR:"Br",BZD:"BZ$",CAD:"$",CDF:"FC",CHE:"CHE",CHF:"CHF",CHW:"CHW",CLF:"CLF",CLP:"$",CNY:"¥",COP:"$",COU:"COU",CRC:"₡",CUC:"$",CUP:"₱",CVE:"$",CZK:"Kč",DJF:"Fdj",DKK:"kr",DOP:"RD$",DZD:"دج",EEK:"kr",EGP:"£",ERN:"Nfk",ETB:"Br",ETH:"Ξ",EUR:"€",FJD:"$",FKP:"£",GBP:"£",GEL:"₾",GGP:"£",GHC:"₵",GHS:"GH₵",GIP:"£",GMD:"D",GNF:"FG",GTQ:"Q",GYD:"$",HKD:"$",HNL:"L",HRK:"kn",HTG:"G",HUF:"Ft",IDR:"Rp",ILS:"₪",IMP:"£",INR:"₹",IQD:"ع.د",IRR:"﷼",ISK:"kr",JEP:"£",JMD:"J$",JOD:"JD",JPY:"¥",KES:"KSh",KGS:"лв",KHR:"៛",KMF:"CF",KPW:"₩",KRW:"₩",KWD:"KD",KYD:"$",KZT:"₸",LAK:"₭",LBP:"£",LKR:"₨",LRD:"$",LSL:"M",LTC:"Ł",LTL:"Lt",LVL:"Ls",LYD:"LD",MAD:"MAD",MDL:"lei",MGA:"Ar",MKD:"ден",MMK:"K",MNT:"₮",MOP:"MOP$",MRO:"UM",MRU:"UM",MUR:"₨",MVR:"Rf",MWK:"MK",MXN:"$",MXV:"MXV",MYR:"RM",MZN:"MT",NAD:"$",NGN:"₦",NIO:"C$",NOK:"kr",NPR:"₨",NZD:"$",OMR:"﷼",PAB:"B/.",PEN:"S/.",PGK:"K",PHP:"₱",PKR:"₨",PLN:"zł",PYG:"Gs",QAR:"﷼",RMB:"￥",RON:"lei",RSD:"Дин.",RUB:"₽",RWF:"R₣",SAR:"﷼",SBD:"$",SCR:"₨",SDG:"ج.س.",SEK:"kr",SGD:"S$",SHP:"£",SLL:"Le",SOS:"S",SRD:"$",SSP:"£",STD:"Db",STN:"Db",SVC:"$",SYP:"£",SZL:"E",THB:"฿",TJS:"SM",TMT:"T",TND:"د.ت",TOP:"T$",TRL:"₤",TRY:"₺",TTD:"TT$",TVD:"$",TWD:"NT$",TZS:"TSh",UAH:"₴",UGX:"USh",USD:"$",UYI:"UYI",UYU:"$U",UYW:"UYW",UZS:"лв",VEF:"Bs",VES:"Bs.S",VND:"₫",VUV:"VT",WST:"WS$",XAF:"FCFA",XBT:"Ƀ",XCD:"$",XOF:"CFA",XPF:"₣",XSU:"Sucre",XUA:"XUA",YER:"﷼",ZAR:"R",ZMW:"ZK",ZWD:"Z$",ZWL:"$",};
const shopCurrencySymbol = currencySymbol[Shopify.currency.active];

/* Get Sibling */
const getSiblings = function (elem) {
  const siblings = [];
  let sibling = elem.parentNode.firstChild;
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== elem) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }
  return siblings;
};

/* Slide Up */
const slideUp = (target, time) => {
  const duration = time ? time : 500;
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + "ms";
  target.style.boxSizing = "border-box";
  target.style.height = target.offsetHeight + "px";
  target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  window.setTimeout(() => {
    target.style.display = "none";
    target.style.removeProperty("height");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
  }, duration);
};
/* Slide Down */
const slideDown = (target, time) => {
  let duration = time ? time : 500;
  target.style.removeProperty("display");
  let display = window.getComputedStyle(target).display;
  if (display === "none") display = "block";
  target.style.display = display;
  const height = target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  target.offsetHeight;
  target.style.boxSizing = "border-box";
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + "ms";
  target.style.height = height + "px";
  window.setTimeout(() => {
    target.style.removeProperty("height");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
  }, duration);
};

const activeClassAction = function (toggle, target) {
  const to = document.querySelector(toggle),
        ta = document.querySelector(target);
  if (to && ta) {
    to.addEventListener("click", function (e) {
      e.preventDefault();
      let triggerItem = e.target;
      if (triggerItem.classList.contains("active")) {
        triggerItem.classList.remove("active");
        ta.classList.remove("active");
      } else {
        triggerItem.classList.add("active");
        ta.classList.add("active");
      }
    });
    document.addEventListener("click", function (event) {
      if (
        !event.target.closest(toggle) &&
        !event.target.classList.contains(toggle.replace(/\./, ""))
      ) {
        if (
          !event.target.closest(target) &&
          !event.target.classList.contains(target.replace(/\./, ""))
        ) {
          to.classList.remove("active");
          ta.classList.remove("active");
        }
      }
    });
  }
};

// Get window top offset
function TopOffset(el) {
  let rect = el.getBoundingClientRect(),
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

// When the section function is visible, disable the observer.
const initSectionVisiable = function(elemnts) {
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (typeof elemnts.callback === 'function') {
          elemnts.callback();
          observer.unobserve(entry.target);
        }
      }
    });
  }, {rootMargin: `0px 0px ${elemnts.margin}px 0px`});
  observer.observe(elemnts.element);
};


/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class DataCountdown extends HTMLElement {
  constructor() {
    super();

    this.onCountDown();
  }

  onCountDown() {
    const CountDownElement = this.querySelector("[data-countdown]");

    const countDownItem = (value, label) => {
      return `<div class="countdown__item ${label}"><span class="countdown__number">${value}</span> <span class="countdown__text">${label}</span></div>`;
    };
    const date = new Date(
        CountDownElement.getAttribute("data-countdown")
      ).getTime(),
      second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24;
    const countDownInterval = setInterval(function () {
      let currentTime = new Date().getTime(),
        timeDistance = date - currentTime,
        daysValue = Math.floor(timeDistance / day),
        hoursValue = Math.floor((timeDistance % day) / hour),
        minutesValue = Math.floor((timeDistance % hour) / minute),
        secondsValue = Math.floor((timeDistance % minute) / second);

      CountDownElement.innerHTML =
        countDownItem(daysValue, window.countdown.days) +
        countDownItem(hoursValue, window.countdown.Hours) +
        countDownItem(minutesValue, window.countdown.minutes) +
        countDownItem(secondsValue, window.countdown.second);

      if (timeDistance < 0) clearInterval(countDownInterval);
    }, 1000);
  }
}
customElements.define("countdown-timer", DataCountdown);


class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));

    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));

    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));

    this.onHideDropdown = this.closeSelector.bind(this);
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
    document.body.removeEventListener('click', this.onHideDropdown);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

    document.body.addEventListener('click', this.onHideDropdown);
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (shouldClose) {
      this.hidePanel();
    }
    let eventTarget = event.target;
    if (!eventTarget.closest('.dropdown__open_label')) {
      this.hidePanel();
    }

  }
}
customElements.define('localization-form', LocalizationForm);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('[grid-recommendation]');
          
          if(recommendations && recommendations.innerHTML.trim().length) {
            this.querySelector('[grid-recommendation]').innerHTML = recommendations.innerHTML;
          }
          
          if(recommendations){
            if(recommendations.innerHTML.trim().length === 0){
              this.parentElement.classList.add('no-js-inline');
            }else{
              this.children[0].classList.remove('no-js-inline');
            }
          }

          if (html.querySelector('.product__card')) {
            this.classList.add('product-recommendations--loaded');
          }

          if(this.dataset.intent == "complementary"){
              let complementaryProducts = new Swiper(this.querySelector(".complementory--slider"), {
              loop: true,
              slidesPerView: 1,
              spaceBetween: 10,  
              autoHeight: true,
              pagination: {
                el: this.querySelector(".swiper-pagination"),
                clickable: true,
              } 
            });
            this.querySelector('.complementary-slideshow--slider').classList.remove('no-js-inline');
            this.querySelector("details") ? this.querySelector("details").open = true : null;
          }

         if(this.dataset.intent == "related" && this.dataset.sliderEnable == "true"){
           let autoplay = false,
                sliderAutoplay = this.dataset.autoplay,
                autoPlayValue = false,
                autoPlayTime = parseInt(this.dataset.autoplayTime),
                sliderContainer = true; 
            if(sliderAutoplay == "true") {
                autoPlayValue = {
                  delay: autoPlayTime,
                };
             }
           if(this.dataset.sliderEnable !== "true") {
              sliderContainer = false;
            }
           
           let relatedProducts = new Swiper(this.querySelector(".productSlider"), {
              loop: true,
              slidesPerView: parseInt(this.dataset.showMobile),
              spaceBetween: 30,
              autoplay: autoPlayValue,
              pagination: {
                el: this.querySelector(".swiper-pagination"),
                clickable: true,
                type: "fraction",
              },
              navigation: {
                nextEl: this.querySelector(".swiper-button-next"),
                prevEl: this.querySelector(".swiper-button-prev"),
              },
              breakpoints: {
                640: {
                  slidesPerView: parseInt(this.dataset.showMobile),
                },
                750: {
                  slidesPerView: parseInt(this.dataset.showTablet),
                },
                992: {
                  slidesPerView: parseInt(this.dataset.showExtraLarge),
                },
              }
            });

           if (sliderContainer && sliderAutoplay == "true") {
              this.querySelector(".productSlider").addEventListener("mouseenter", (e) => {
                relatedProducts.autoplay.stop();
              });
              this.querySelector(".productSlider").addEventListener("mouseleave", (e) => {
                relatedProducts.autoplay.start();
              });
            }
          }
          
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);